import { createFileRoute, redirect } from '@tanstack/react-router';
import { TrocarSenhaPage } from '@/components/conta';
import { getToken } from '@/lib/session';

/** Fora do shell: serve ao primeiro login (token TROCA_SENHA). Sem token, volta ao login. */
export const Route = createFileRoute('/trocar-senha')({
  beforeLoad: () => {
    if (!getToken()) throw redirect({ to: '/login' });
  },
  component: TrocarSenhaPage,
});
